import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  height: fit-content;
  background: #FFFFFF;
  border: 1px solid #CED8D8;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  padding: 24px 0 24px 44px;

  && header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding-right: 24px;

    strong {
      color: #3D6666;
      font-weight: 900;
      font-size: 24px;
      line-height: 33px;
    }

    h6 {
      color: rgba(31, 32, 44, 0.6);
      font-weight: 500;
      font-size: 24px;
      line-height: 33px;
    }
  }

  table {
    width: 100%;
    border-spacing: 0;
    table-layout: fixed;

    th {
      text-align: left;
      color: #7B7C82;
      font-weight: 900;
      font-size: 14px;
      line-height: 19px;
      border-bottom: 1px solid #EFEFEF;
      padding-bottom: 12px;
    }

    td {
      color: #1F202C;
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      padding-top: 8px;
      padding-right: 12px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
`